import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import Shipping from './pages/Shipping';
import Register from './pages/Register';
import Product from './pages/Product';

const TabLink = ({ to, children }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  
  return (
    <li className="nav-item">
      <Link 
        to={to} 
        className={`nav-link ${isActive ? 'active' : ''}`}
      >
        {children}
      </Link>
    </li>
  );
};

function App() {
  return (
    <Router>
      <div className="container mt-4">
        <ul className="nav nav-tabs">
          <TabLink to="/">Fretes</TabLink>
          <TabLink to="/register">Registro de Rotas</TabLink>
          <TabLink to="/product">Registro de Produtos</TabLink>
        </ul>
        
        <div className="tab-content p-3 border border-top-0">
          <Routes>
            <Route path="/" element={<Shipping />} />
            <Route path="/register" element={<Register />} />
            <Route path="/product" element={<Product />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;